import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaMedidas extends React.Component {
  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/otros/medidas/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];

    const { medidas } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={this.props.pagination}
        dataSource={medidas}
        title={() => <h2 style={{ textAlign: 'center' }}> Medidas </h2>}
        locale={{
          emptyText: 'No hay medidas cargadas',
        }}
      />
    );
  }
}

export default TablaMedidas;
